import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

function ResourceOptions(props) {
  const { t } = useTranslation();
  return (
    <>
      <Grid
        id="hide"
        className="resource-options-container options-container"
        // style={{
        //   marginRight: '0px',
        //   marginLeft: '0px',
        //   paddingLeft: '15px',
        //   paddingRight: '15px',
        // }}
      >
        <Grid items xs={6} className="options-container-left">
          <h1>{t('sections-NavBar-ResourceOptions-heading')}</h1>
          <p>{t('sections-NavBar-ResourceOptions-headingDesc')}</p>
          <button
            className="btn subNavBtn "
            onClick={() => {
              props.navigateTo('calculatorsSection');
              document.querySelector('#hide').id = 'hideafter';
              setTimeout(() => {
                document.querySelector('#hideafter').id = 'hide';
              }, 1000);
            }}
          >
            {t('sections-NavBar-ResourceOptions-GotoResources')}
          </button>
        </Grid>
        <Grid items xs={6} className="options-container-right">
          <Grid align="center" style={{ display: 'flex' }}>
            <Grid
              items
              md={4}
              className="option"
              onClick={() => {
                props.navigateTo('calculatorsSection');
                document.querySelector('#hide').id = 'hideafter';
                setTimeout(() => {
                  document.querySelector('#hideafter').id = 'hide';
                }, 1000);
              }}
            >
              {t('sections-NavBar-ResourceOptions-Calculator')}
            </Grid>
            <Grid
              items
              md={4}
              className="option"
              onClick={() => {
                props.navigateTo('formSection');
                document.querySelector('#hide').id = 'hideafter';
                setTimeout(() => {
                  document.querySelector('#hideafter').id = 'hide';
                }, 1000);
              }}
            >
              {t('sections-NavBar-ResourceOptions-Forms')}
            </Grid>
            <Grid
              items
              md={4}
              className="option"
              onClick={() => {
                props.navigateTo('videoGallery');
                document.querySelector('#hide').id = 'hideafter';
                setTimeout(() => {
                  document.querySelector('#hideafter').id = 'hide';
                }, 1000);
              }}
            >
              {t('sections-NavBar-ResourceOptions-Video')}
            </Grid>
            {/* <div className="col-4  option"
              onClick={()=>{
                document.querySelector('#hide').id='hideafter'; 
                setTimeout(() => {
                  document.querySelector('#hideafter').id='hide';
                }, 1000);
              }}
            >Case Study</div> */}
            <Grid
              items
              md={4}
              className="option"
              onClick={() => {
                props.navigateTo('Blogarea');
                document.querySelector('#hide').id = 'hideafter';
                setTimeout(() => {
                  document.querySelector('#hideafter').id = 'hide';
                }, 1000);
              }}
            >
              {t('sections-NavBar-ResourceOptions-Blog')}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
export default ResourceOptions;
